// extracted by mini-css-extract-plugin
export var bar = "style-module--bar--QjfAi";
export var code = "style-module--code--FIKuf";
export var columnCode = "style-module--columnCode--4IfI3";
export var columnRoot = "style-module--columnRoot--Su-UJ";
export var columnText = "style-module--columnText--fNZ7G";
export var root = "style-module--root--sxfmx";
export var text = "style-module--text--BL9dY";